export default class DateTimeFileName extends Date {
    override toString(): string {
        return `${this.getFullYear()}`.padStart(4,'0') +
        `${this.getMonth()+1}`.padStart(2,'0') +
        `${this.getDate()}`.padStart(2,'0') +
        `${this.getHours()}`.padStart(2,'0') +
        `${this.getMinutes()}`.padStart(2,'0') +
        `${this.getSeconds()}`.padStart(2,'0');
    }
}